import React from 'react';

import { Link } from 'gatsby';

import { Button, styled } from '@mui/material';

type Props = {
  item: {
    slug: string;
    name: string;
    claim: string;
    image: React.ReactElement;
  };
  langPrefix: string;
  general_more_information_label: string;
};

export const ServiceSegmentGridItem = ({
  item,
  langPrefix,
  general_more_information_label,
}: Props) => {
  return (
    <ServiceSegmentsGridItem
      to={`${langPrefix}/${item.slug}`}
      className="link-container"
    >
      {item.image}
      <Title>{item.name}</Title>
      <Claim>{item.claim}</Claim>
      <Button
        sx={{
          justifySelf: 'flex-start',
          alignSelf: 'flex-end',
          marginTop: 'var(--spacer-xxs)',
          marginBottom: { xs: '12px', sm: '14px', lg: '23px', xl: '30px' },
        }}
        component="p"
        variant="text"
      >
        {general_more_information_label}
      </Button>
    </ServiceSegmentsGridItem>
  );
};

const Title = styled('h3')(({ theme }) => ({
  ...theme.typography.h6,
  color: 'var(--color-dark-coal)',
  margin: '10px 0px 5px',
  hyphens: 'auto',
  wordBreak: 'break-word',
}));

const Claim = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  color: 'var(--color-dark-coal)',
  margin: 0,

  [theme.breakpoints.up('sm')]: {
    margin: '0 0 20px 0',
  },
}));

const ServiceSegmentsGridItem = styled(Link)(({ theme }) => ({
  padding: 0,
  transition: 'var(--transition-duration)',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto auto 1fr',

  [theme.breakpoints.up('sm')]: {
    padding: '8px',
    ':hover': {
      boxShadow: '0px 0px 24px 4px rgba(211, 211, 211)',
    },
  },

  [theme.breakpoints.up('md')]: {
    padding: '10px',
  },
}));
